import { createSlice } from '@reduxjs/toolkit';
import { findPushNotificationManagement, createPushNotificationManagement } from './api';
import { initialState } from './api/interface';

const notificationManagementSlice = createSlice({
  name: 'notificationManagement',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findPushNotificationManagement.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findPushNotificationManagement.fulfilled, (state, action) => {
      state.count = action.payload.count;
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findPushNotificationManagement.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createPushNotificationManagement.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createPushNotificationManagement.fulfilled, (state, action) => {
      if (action?.payload?.count) {
        state.count = action?.payload?.count;
      } else {
        state.data.push(action.payload);
      }
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createPushNotificationManagement.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = notificationManagementSlice.actions;
export default notificationManagementSlice.reducer;
